(() => {
  const styleId = 'edulit-newsletter-form-polish';
  const override = `
    .exponea-subscription-dialog {
      --blue: #131db2;
      --blue-pale: #eaf6ff;
      --cream: #eaf6ff;
      width: min(88rem, calc(100vw - 4rem));
      max-width: 88rem;
      padding: clamp(2.8rem, 4vw, 4.8rem);
      border: 1px solid rgba(19, 29, 178, 0.12);
      border-radius: 2.4rem;
      background: var(--blue-pale);
      box-shadow: none;
    }

    .exponea-subscription-dialog h1 {
      font-family: var(--font-heading, inherit);
      font-size: clamp(2.8rem, 3vw, 4rem);
    }

    .exponea-subscription-dialog form {
      column-gap: 2rem;
      row-gap: 1.8rem;
    }

    .exponea-subscription-dialog .exponea-input {
      min-height: 4.8rem;
      border-color: rgba(19, 29, 178, 0.2);
      background: #ffffff;
    }

    .exponea-nivel-group {
      border-color: rgba(19, 29, 178, 0.2);
      background: rgba(255, 255, 255, 0.72);
    }

    .exponea-subscription-dialog .exponea-button {
      min-height: 4.8rem;
      padding-inline: 3.6rem;
      background: var(--blue);
      border-radius: 0.8rem;
    }

    .exponea-subscription-dialog .exponea-button:hover,
    .exponea-subscription-dialog .exponea-button:focus-visible {
      background: #0d168d;
    }

    @media (max-width: 600px) {
      .exponea-subscription-dialog {
        width: calc(100vw - 3.2rem);
        padding: 2.4rem 2rem;
        border-radius: 1.8rem;
      }
    }
  `;

  const polishNewsletterForm = () => {
    const hosts = Array.from(document.querySelectorAll('*')).filter((element) => element.shadowRoot);
    let applied = false;

    hosts.forEach((host) => {
      const root = host.shadowRoot;
      if (!root.querySelector('.exponea-subscription-dialog') || root.getElementById(styleId)) return;

      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = override;
      root.appendChild(style);
      applied = true;
    });

    return applied;
  };

  if (polishNewsletterForm()) return;

  const observer = new MutationObserver(() => {
    if (polishNewsletterForm()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(() => observer.disconnect(), 30000);
})();
